import React from 'react';
import { BrowserRouter as Router,
		Routes,
		Route } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

// custom theme:
import theme 		from './Theme';

// custom modules:
import AlertDialog 	from './components/AlertDialog';
import NavBar 		from './components/NavBar';
import FetchRequest from './components/FetchRequest';

// page files:
import MeasureOverview 	 	from "./pages/overview";
import About 		from "./pages/about";
import Contact 		from "./pages/contact";
import MeasurePage  from './pages/measure';
import Explanation  from './pages/explanation';
import SiteGuide from './pages/guide';
import Downloads from './pages/downloads';



function App() {
	// sessionStorage.clear()

	// Only run once, take the last FetchRequest as value in the IF-statement
		FetchRequest("fullmeasures")
		FetchRequest("measureTable");
		FetchRequest("countryMeasures");
		FetchRequest("getfullgeojson");
		FetchRequest("count")
		FetchRequest("getHorizontalBarData")
	document.title = 'CEDR SAFEPATH';

  	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<AlertDialog />
			<Router>
				<NavBar />
				<Routes>
					<Route path="/" 					element={<About />} />
					<Route path="/measures"  			element={<MeasureOverview />} />
					<Route path="/contact" 				element={<Contact />} />
					<Route path="/measure/:id" 			element={<MeasurePage />} />
					<Route path="/explanation"			element={<Explanation />} />
					<Route path="/guide"				element={<SiteGuide />} />
					<Route path="/downloads"			element={<Downloads />} />
				</Routes>
			</Router>
		</ThemeProvider>
	)
}

export default App;
